define([
	'jquery',
	'toolkit/b-controls-group/b-controls-group'

], function($) {
	return function(app) {
		var upload = app.upload;

		var loader = new patron.toolkit['b-controls-group']({
			  el: '#loader'
			, template: 'app'
			, templateBlock: 'loader'

			, data: {
				entries: []
				, expanded: app.user.getParam('ui.expand_loader', true)
			}

			, _$fileList: {}
			, _$headerButtons: null
			, _$headerIcon: null
			, _$headerTitle: null
			, _$headerCancel: null
			, _$list: null

			, init: function() {
				patron.toolkit['b-controls-group'].fn.init.call(this);

				var _this = this;

				app.upload
					.on('queue:start', function(evt, entries) {
						var isLoading = _this.data.entries && _this.data.entries.length;

						Array.append(_this.data.entries, entries);

						if (isLoading){
							_this._updateAll();
						} else {
							_this.render();
						}
					})

					.on('file:start file:complete file:abort', function(evt, file, progressSupport) {
						if( progressSupport === false ) {// CLOUD-1701
							file.noprogress = true;
						}

						if ( !file.silent ) {// CLOUDWEB-4798 abort all
							_this._update(file);
						}
					})

					.on('file:abortall', function() {
						_this._updateAll();// CLOUDWEB-4798
					})

					.on('file:progress', function(evt, file, loaded, total) {
						if( file.noprogress ) {
							return;
						}

						var progress = ( loaded / total ) * 100;

						if( progress > 100 ) {
							// XMLHttpRequest progress event loaded and total out of bounds with big (more when 300Mb) files
							// https://jira.mail.ru/browse/CLOUD-1212
							// https://bugzilla.mozilla.org/show_bug.cgi?id=614352
							progress = 90;
						}

						file.progress = progress;

						_this._getNode(file.uid).find('.loader__list__item__progressbar__value').css('width', file.progress + '%');
					})
				;
			}

			, _update: function(file) {
				for ( var array = this.data.entries, i = 0, len = array.length ; i < len ; i++ ) {
					var item = array[i];
					if(item.uid === file.uid) {
						array[i] = file;
					}

				}

				this._throttleUpdateHeader(); // cloudweb-4663

				this._getNode(file.uid).html($.fest(this.template, {
					  block: 'loader__list__item'
					, params: file
				}));
			}

			, _updateAll: function() { // cloudweb-4663
				this._$fileList = {};

				this._updateHeader();

				this._getListNode().html($.fest(this.template, {
					  block: 'loader__list'
					, params: {
						files: upload.entries
					}
				}));
			}

			, _throttleUpdateHeader: function () { // cloudweb-4663
				var delay = 400;

				if ( this._updateHeaderTimeoutId ) {
					clearTimeout(this._updateHeaderTimeoutId);
					this._updateHeaderTimeoutId = null;
				}

				if ( !this._lastHeaderUpdateTime ) { // first run
					this._updateHeader = this._updateHeader.bind(this);
					this._updateHeader();

				} else if ( Date.now() - this._lastHeaderUpdateTime > delay ) {
					this._updateHeader();

				} else {
					this._updateHeaderTimeoutId = setTimeout(this._updateHeader, delay);
				}
			}

			, _getDataForHeaderPartials: function() {
				var array = Array.isArray(this.data.entries) ? this.data.entries : [];
				var totalEntries = array.length;
				var stat = {
					total:   0,
					loading: 0,
					error:   0,
					done:    0,
					aborted: 0,
					queued:  0
				};
				var isCancelable = false;
				var titleCase = 0;
				var titleCurrent;
				var titleTotal;
				var item;
				var _i;

				for (_i = 0 ; _i < totalEntries ; _i++) {
					item = array[_i];
					stat[item.state]++;
				}

				stat.total = totalEntries;
				titleTotal = stat.total;

				if (stat.loading || stat.queued) {
					titleCase = 1;
					titleCurrent = stat.loading + stat.queued;
					isCancelable = true;
				} else if((stat.error || stat.aborted) && stat.error + stat.aborted !== stat.total) {
					titleCase = 2;
					titleCurrent = stat.aborted + stat.error;
				} else if((stat.error || stat.aborted) && stat.error + stat.aborted == stat.total) {
					titleCase = 3;
				} else {
					titleCurrent = stat.loading + stat.queued;
				}

				return {
					titleCase: titleCase,
					titleCurrent: titleCurrent,
					titleTotal: titleTotal,
					closeButtonDisabled: stat.loading,
					showLoaderHeaderIcon: stat.loading || stat.queued,
					showLoaderHeaderCancel: isCancelable
				};
			}

			, _updateHeader: function() {
				var params = this._getDataForHeaderPartials();

				this._getHeaderButtonsNode().html($.fest(this.template, {
					  block: 'loader__header__buttons'
					, params: params
				}));

				// При каждом событии drag'n'drop срабатывает метод _render(),
				// который уничтожает ссылку на _$headerIcon. При добавлении хотя бы
				// одного файла в список загрузки вызывается метод _updateHeader.
				// Устанавливается ссылка на _$headerIcon, изменяется ее HTML.
				// Чтобы не отрисовывать содержимое _$headerIcon при каждом вызове
				// _updateHeader, проверяем существование ссылки на _$headerIcon.
				// Также, когда все файлы для загрузки были обработаны (успешно
				// загрузились либо нет), необходимо скрывать _$headerIcon.
				// Для этого используем проверку params.showLoaderHeaderIcon.
				if (!this._$headerIcon || !params.showLoaderHeaderIcon) {
					this._getHeaderIconNode().html($.fest(this.template, {
						  block: 'loader__header__icon'
						, params: {
							visible: params.showLoaderHeaderIcon
						}
					}));
				}

				this._getHeaderTitleNode().html($.fest(this.template, {
					  block: 'loader__header__title'
					, params: params
				}));

				this._getHeaderCancelNode().html($.fest(this.template, {
					  block: 'loader__header__cancel'
					, params: {
						visible: params.showLoaderHeaderCancel
					}
				}));

				this._lastHeaderUpdateTime = Date.now(); // cloudweb-4663
			}

			, _getHeaderButtonsNode: function() {
				if(!this._$headerButtons) {
					this._$headerButtons = this.$('.js-loader__header__buttons');
				}

				return this._$headerButtons;
			}

			, _getHeaderIconNode: function() {
				if(!this._$headerIcon) {
					this._$headerIcon = this.$('.js-loader__header__icon');
				}

				return this._$headerIcon;
			}

			, _getHeaderTitleNode: function() {
				if(!this._$headerTitle) {
					this._$headerTitle = this.$('.js-loader__header__title');
				}

				return this._$headerTitle;
			}

			, _getHeaderCancelNode: function() {
				if(!this._$headerCancel) {
					this._$headerCancel = this.$('.js-loader__header__cancel');
				}

				return this._$headerCancel;
			}

			, _getNode: function(id) {
				if(!this._$fileList[id]) {
					this._$fileList[id] = this.$('.loader__list__item[data-file-id="' + id + '"]');
				}

				return  this._$fileList[id];
			}

			, _getListNode: function() { // cloudweb-4663
				if(!this._$list) {
					this._$list = this.$('.loader__list');
				}

				return this._$list;
			}

			, render: function() {
				patron.toolkit['b-controls-group'].fn.render.call(this);

				this.container = this.$('.loader');
				this.container.show();

				this._$fileList = {};
				this._$headerButtons = null;
				this._$headerIcon = null;
				this._$headerTitle = null;
				this._$headerCancel = null;
				this._$list = null;
			}

			, onCancel: function(evt, ui) {
				var id = ui.$el.parent('.loader__list__item').data('file-id');
				upload.abort(id, 'cancel');
			}

			, onCancelAll: function(evt, ui) {
				upload.abortAll('cancel'); // cloudweb-4798
			}

			, onClose: function(evt) {
				this.container.hide();
				this.data.entries = [];
			}

			, _toggleList: function(value) {
				this.data.expanded = value;
				patron.toolkit.toggleMod(this.container, 'expanded', value);
				app.user.setParam('ui.expand_loader', value);
			}

			, onMinimize: function(evt) {
				this._toggleList(false);
			}

			, onExpand: function(evt) {
				this._toggleList(true);
			}
		});

		return loader;
	}
});

